const filterCompanyPages = (urls) => {
    const companyKeywords = [
        "about", "our-story", "our-company", "who-we-are", "contact", "products",
        "services", "solutions", "what-we-do", "offerings", "blog", "news",
        "resources", "insights", "faq", "help", "pricing", "plans", "privacy",
        "terms-and-conditions", "terms-of-use", "case-studies", "projects",
        "portfolio", "testimonials", "reviews",
    ];
    //  Filter URLs based on keywords
    const matched = urls.filter((url) =>
        companyKeywords.some((keyword) =>
            url.toLowerCase().includes(keyword.toLowerCase())
        )
    );
    //  100 limit logic remove  
    // Final list should show ALL matching + ALL other URLs
    // const remaining = urls.filter((url) => !matched.includes(url));
    const finalList = [...matched];  //  No limit here


    //  First 10 new URLs converted into object format
    const first10 = finalList.map((url) => ({
        url,
        checkedStatus: true,
    }));
    return first10; //  Return all URLs now
};

export default filterCompanyPages;
